import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index'

// デザイン別設定
const routerOptions = [
  { path: '/', name: 'Dashboard', component: 'Dashboard' },
  { path: '/login', name: 'Login', component: 'Login', meta: { isPublic: true } },
  { path: '/members', name: 'Members', component: 'Members' },
  { path: '/kakinlog', name: 'KakinLog', component: 'KakinLog' },
  { path: '/kmaillog', name: 'KmailLog', component: 'KmailLog' },
  { path: '/paymentlog', name: 'PaymentLog', component: 'PaymentLog' },
  { path: '/payupdate', name: 'Payupdate', component: 'Payupdate' },
  { path: '/mountainarea', name: 'MountainArea', component: 'MountainArea' },
  { path: '/mountains', name: 'Mountains', component: 'Mountains' },
  { path: '/livecamera', name: 'Livecamera', component: 'Livecamera' },
  { path: '/typhoon', name: 'Typhoon', component: 'Typhoon' },
  { path: '/news', name: 'News', component: 'News' },
  { path: '/news1', name: 'News1', component: 'News1' },
  { path: '/news2', name: 'News2', component: 'News2' },
  { path: '/characteristic', name: 'Characteristic', component: 'Characteristic' },

  { path: '/maillog', name: 'Maillog', component: 'Maillog' },
  { path: '/noticemail', name: 'Noticemail', component: 'Noticemail' },
  { path: '/fcstmail', name: 'Fcstmail', component: 'Fcstmail' },
  { path: '/stormmail', name: 'Stormmail', component: 'Stormmail' },
  { path: '/recommendmail', name: 'Recommendmail', component: 'Recommendmail' },
  { path: '/weekmail', name: 'Weekmail', component: 'Weekmail' },
  { path: '/typhoonmail', name: 'Typhoonmail', component: 'Typhoonmail' },

  { path: '/users', name: 'Users', component: 'Users' }
]

const routes = routerOptions.map(route => {
  return {
    ...route,
    component: () => import(`@/components/${route.component}.vue`)
  }
})

Vue.use(Router)
const router = new Router({
  routes,
  base: process.env.ROUTER_BASE,
  mode: 'history'
})

// public判定
router.beforeEach((to, from, next) => {
  console.log(to)
  if (!to.meta.isPublic && !store.state.auth.loggedIn) {
    next({ name: 'Login', query: { redirect: to.fullPath } })
  } else {
    next()
    store.commit('activeSidebar', to.name)
    console.log('setActive', to.name)
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js